import { belongsTo, hasMany, attr } from '@ember-data/model';
import ShModel from './sh-model';
import { computed } from '@ember/object';

const TYPES = {
  COUNTRY: 'country',
  GLOBAL: 'global',
  REGION: 'region',
};

export const LOCATION = {
  TYPES,
};

const Location = ShModel.extend({
  formattedAddress: attr(),
  googleId: attr(),
  countryName: attr('string'),
  countryShort: attr(),
  locality: attr(),
  locationType: attr('string'),
  sublocality: attr(),
  lat: attr(),
  lng: attr(),
  viewport: attr(),
  adminArea: attr(),
  placeId: attr('string'),
  countryId: attr('number'),
  regionId: attr('number'),

  //Relationships
  country: belongsTo('country', { async: false }),
  region: belongsTo('region', { async: false }),
  user: hasMany('user', { async: false }),
  company: belongsTo('company', { async: false }),

  getGoogleMapsLink: computed(
    'placeId',
    function () {
      const placeId = this.get('placeId');
      const formattedAddress = encodeURIComponent(this.get('formattedAddress')).replace(/%20/g, "+");

      if (placeId) {
        return `https://www.google.com/maps/search/?api=1&query=${formattedAddress}&query_place_id=${placeId}`;
      } else {
        return `https://www.google.com/maps/place/?q=place_id:${placeId}`;
      }
    }
  ),

  isGlobal: computed(
    'locationType',
    function() {
      return this.locationType === TYPES.GLOBAL;
    }
  ),
});

export default Location;
